<template>
    <div class="setMealAllocation table-hook fadeInRight">
        <div class="title-box">
            <span class="m-title">分配套餐*</span>
            <el-form
                ref="form"
                :model="form"
                inline
                class="hook right themed-form search-form"
            >
                <el-form-item label="分销商:">
                    <!-- <search-select :optionsMetaAll="agentList"  v-model="form.agentId" @input="_getsetmealByagentId">
                </search-select> -->
                    <el-select
                        v-model="form.agentId"
                        filterable
                        @change="_getsetmealByagentId"
                    >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-if="
                                agentType == 4 &&
                                agentTree == 1 &&
                                settl_type != 1
                            "
                            :label="agentThreeName"
                            :value="loginAgentId"
                        ></el-option>
                        <el-option
                            v-for="item in agentList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分配状态:">
                    <el-select
                        v-model="form.distributionStatus"
                        placeholder="全部"
                    >
                        <el-option label="全部" value=""></el-option>
                        <el-option label="已分销" value="1"></el-option>
                        <el-option label="未分销" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属类别:">
                    <!-- <el-select v-model="form.category" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="电信" value="1"></el-option>
                    <el-option label="移动" value="3"></el-option>
                    <el-option label="联通" value="4"></el-option>
                    <el-option label="联通Q" value="6"></el-option>
                    <el-option label="DCP电信" value="5"></el-option>
                    <el-option label="新移动" value="7"></el-option>
                    <el-option label="新联通" value="8"></el-option>
                </el-select> -->
                    <el-select
                        v-model="form.category"
                        filterable
                        @change="getSecondLists"
                    >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-for="(item, index) in $store.getters.categorys"
                            :label="item.name"
                            :value="item.value"
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="子类别:"
                    v-if="
                        (agentType == '4' && agentTree == '1') ||
                        agentType == '1'
                    "
                >
                    <el-select
                        v-model="form.secondCategory"
                        @visible-change="secondClick"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in accountLists"
                            :key="item.index"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐名称:">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <!-- <el-form-item label="子类别:">
                <el-input v-model="form.secondCategoryStr"></el-input>
            </el-form-item> -->

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="themed-button"
                        @click="reloadPageData"
                        >搜索查询</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
            >
                <el-table-column
                    label="套餐名称"
                    prop="name"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="套餐类型"
                    prop="typeString"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="二级套餐类型"
                    prop="secondTypeString"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="所属类别" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ categoryString(scope.row.category) }}</span>
                        <!-- <span v-if="scope.row.category == 1">电信</span>
                   <span v-if="scope.row.category == 2">其他卡务</span>
                   <span v-if="scope.row.category == 3">移动</span>
                   <span v-if="scope.row.category == 6">联通Q</span>
                   <span v-if="scope.row.category == 5">DCP电信</span>
                   <span v-if="scope.row.category == 7">新移动</span>
                   <span v-if="scope.row.category == 8">新联通</span>
                   <span v-if="scope.row.category == 4">联通</span> -->
                    </template>
                </el-table-column>
                <el-table-column
                    label="子类别"
                    prop="secondCategoryStr"
                ></el-table-column>
                <el-table-column
                    label="套餐原价"
                    prop="originalMoney"
                ></el-table-column>
                <el-table-column
                    label="首次充值售价"
                    prop="money"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="首次充值提现比例"
                    prop="rebateRatio"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="二次充值"
                    min-width="100"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span class="recharge-ratio-cell">{{
                            formatTierRechargeDisplay(scope.row, "second")
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="三次充值"
                    min-width="100"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span class="recharge-ratio-cell">{{
                            formatTierRechargeDisplay(scope.row, "third")
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="后续充值"
                    min-width="100"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span class="recharge-ratio-cell">{{
                            formatTierRechargeDisplay(scope.row, "subsequent")
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="分配状态" prop="type">
                    <template slot-scope="scope">
                        <span v-if="scope.row.distributionStatus === 1"
                            >已分配</span
                        >
                        <span v-else-if="scope.row.distributionStatus === 2"
                            >未分配</span
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    label="排序"
                    prop="mealSort"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <!-- <span v-if="scope.row.distributionStatus == 1">{{scope.row.agentOrder}}</span>
                   <span v-if="scope.row.distributionStatus == 2">-</span> -->
                        <el-input
                            v-if="scope.row.distributionStatus == 1"
                            v-model="scope.row.agentOrder"
                            @change="
                                (val) => {
                                    updateSort(
                                        val,
                                        scope.row.agentSetMealId,
                                        1
                                    );
                                }
                            "
                        ></el-input>
                        <span v-if="scope.row.distributionStatus == 2">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="无佣金标识" prop="noProfitFlag">
                    <template slot-scope="scope">
                        <span
                            v-if="scope.row.noProfitFlag == 1"
                            style="color: #f00"
                            >无佣金</span
                        >
                        <span
                            v-else-if="scope.row.noProfitFlag == 0"
                            style="color: #f00"
                        ></span>
                        <span v-else style="color: #f00"></span>
                    </template>
                </el-table-column>
                <el-table-column label="显示" width="105px">
                    <template slot-scope="scope">
                        <el-select
                            v-model="scope.row.hideFlagStr"
                            @change="
                                (val) => {
                                    updateSort(
                                        val,
                                        scope.row.agentSetMealId,
                                        2
                                    );
                                }
                            "
                            v-if="scope.row.distributionStatus == 1"
                        >
                            <el-option label="显示" value="0"></el-option>
                            <el-option label="不显示" value="1"></el-option>
                        </el-select>
                        <span v-if="scope.row.distributionStatus == 2">-</span>
                        <!-- <el-input v-model="scope.row.mealSort" @change="((val)=>{updateSort(val,scope.row.id,false)})"></el-input> -->
                    </template>
                </el-table-column>
                <el-table-column label="标签" prop="label" width="90px">
                    <template slot-scope="scope">
                        <el-input
                            v-model="scope.row.label"
                            @change="
                                (val) => {
                                    updateSort(
                                        val,
                                        scope.row.agentSetMealId,
                                        3
                                    );
                                }
                            "
                            v-if="scope.row.distributionStatus == 1"
                        ></el-input>
                        <span v-if="scope.row.distributionStatus == 2">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐标记" prop="redMark" width="120px">
                    <template slot-scope="scope">
                        <el-input
                            v-model="scope.row.redMark"
                            @change="
                                (val) => {
                                    updateSort(
                                        val,
                                        scope.row.agentSetMealId,
                                        4
                                    );
                                }
                            "
                            v-if="scope.row.distributionStatus == 1"
                        ></el-input>
                        <span v-if="scope.row.distributionStatus == 2">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span v-if="scope.row.distributionStatus == 1">
                            <el-button
                                type="danger"
                                class="themed-button"
                                @click="
                                    deleteInterest(scope.row.agentSetMealId)
                                "
                                >移除</el-button
                            >
                            <el-button
                                type="primary"
                                class="themed-button"
                                v-if="
                                    !(
                                        !(agentType == 4 && agentTree == 1) &&
                                        scope.row.noProfitFlag == 1
                                    ) &&
                                    !(
                                        agentType == 4 &&
                                        agentTree == 1 &&
                                        form.agentId == loginAgentId
                                    )
                                "
                                @click="
                                    editSetMeal(
                                        scope.row.agentSetMealId,
                                        scope.row.noProfitFlag
                                    )
                                "
                                >编辑</el-button
                            >
                        </span>
                        <el-button
                            v-if="
                                scope.row.distributionStatus == 1 &&
                                agentType == 4 &&
                                agentTree == 1
                            "
                            type="warning"
                            size="mini"
                            class="themed-button"
                            @click="
                                setup(
                                    scope.row.agentSetMealId,
                                    scope.row.accountId
                                )
                            "
                            >配置</el-button
                        >
                        <el-button
                            v-if="scope.row.distributionStatus == 2"
                            type="danger"
                            class="themed-button"
                            @click="addSetMeal(scope.row.id)"
                            >分销</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 50, 100, 1000]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>

        <el-dialog title="编辑套餐" :visible.sync="dialogBox" v-if="dialogBox">
            <el-form
                label-position="right"
                label-width="150px"
                :model="formSet"
            >
                <el-form-item label="套餐名称:" required>
                    <el-input v-model="formSet.mealName" readonly></el-input>
                </el-form-item>
                <el-form-item label="首次充值成本价:" required>
                    <el-input v-model="formSet.originalMoney"></el-input>
                    <span v-if="showMiniOriginalMoneyTip" class="form-tip">
                        上级价格：{{ miniOriginalMoney }}，不可低于该值
                    </span>
                </el-form-item>
                <el-form-item
                    label="充值售价:"
                    required
                    v-if="isSellPriceSellMode"
                >
                    <el-input v-model="formSet.money"></el-input>
                    <span v-if="parentMoney != null" class="form-tip">
                        上级价格：{{ parentMoney }}，不可低于该值
                    </span>
                </el-form-item>
                <el-form-item
                    label="首次充值提现比例:"
                    required
                    v-if="!isSellPriceSellMode"
                >
                    <el-input-number
                        v-model="formSet.rebateRatio"
                        controls-position="right"
                        :precision="0"
                        :min="0"
                        :max="rebateRatioMaxLimit"
                    ></el-input-number>
                    <span>%</span>
                    <span v-if="maxRebateRatioPercent != null" class="form-tip">
                        上级设置比例：{{ maxRebateRatioPercent }}%，不可高于该值
                    </span>
                </el-form-item>
                <el-form-item label="返利方式:" v-if="!!agentIdVip">
                    <el-select
                        v-model="formSet.sellType"
                        @change="changeSellType"
                        :disabled="currentNoProfitFlag == 1"
                    >
                        <el-option
                            label="-未设置返利模式-"
                            value="0"
                        ></el-option>
                        <el-option label="提现比模式" value="1"></el-option>
                        <el-option
                            label="销售价模式"
                            value="2"
                            v-if="!isWujiMeal"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="阶梯返利:" v-if="showTieredRebateControl">
                    <el-select
                        v-model="tieredRebateEnable"
                        placeholder="请选择"
                        style="width: 100%"
                        @change="onTieredRebateEnableChange"
                    >
                        <el-option label="关闭" value="0"></el-option>
                        <el-option label="开启" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <template v-if="isTieredRebateRatioMode">
                    <el-form-item label="二次充值比:">
                        <el-input-number
                            v-model="formSet.secondRechargeRatio"
                            controls-position="right"
                            :precision="0"
                            :min="0"
                            :max="rebateRatioMaxLimit"
                            :disabled="!tieredRebateEditable"
                            :class="{
                                'field-readonly-gray': !tieredRebateEditable,
                            }"
                        ></el-input-number>
                        <span>%</span>
                    </el-form-item>
                    <el-form-item label="三次充值比:">
                        <el-input-number
                            v-model="formSet.thirdRechargeRatio"
                            controls-position="right"
                            :precision="0"
                            :min="0"
                            :max="rebateRatioMaxLimit"
                            :disabled="!tieredRebateEditable"
                            :class="{
                                'field-readonly-gray': !tieredRebateEditable,
                            }"
                        ></el-input-number>
                        <span>%</span>
                    </el-form-item>
                    <el-form-item label="后续充值比:">
                        <el-input-number
                            v-model="formSet.subsequentRechargeRatio"
                            controls-position="right"
                            :precision="0"
                            :min="0"
                            :max="rebateRatioMaxLimit"
                            :disabled="!tieredRebateEditable"
                            :class="{
                                'field-readonly-gray': !tieredRebateEditable,
                            }"
                        ></el-input-number>
                        <span>%</span>
                    </el-form-item>
                </template>
                <template v-if="isTieredSellPriceMode">
                    <el-form-item label="二次充值成本:">
                        <el-input
                            v-model="formSet.secondRechargeCost"
                            :clearable="tieredRebateEditable"
                            maxlength="30"
                            :readonly="!tieredRebateEditable"
                            :class="{
                                'field-readonly-gray': !tieredRebateEditable,
                            }"
                            placeholder="须高于套餐原价且低于套餐售价"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="三次充值成本:">
                        <el-input
                            v-model="formSet.thirdRechargeCost"
                            :clearable="tieredRebateEditable"
                            maxlength="30"
                            :readonly="!tieredRebateEditable"
                            :class="{
                                'field-readonly-gray': !tieredRebateEditable,
                            }"
                            placeholder="须高于套餐原价且低于套餐售价"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="后续充值成本:">
                        <el-input
                            v-model="formSet.subsequentRechargeCost"
                            :clearable="tieredRebateEditable"
                            maxlength="30"
                            :readonly="!tieredRebateEditable"
                            :class="{
                                'field-readonly-gray': !tieredRebateEditable,
                            }"
                            placeholder="须高于套餐原价且低于套餐售价"
                        ></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="排序:" required>
                    <el-input v-model="formSet.mealSort"></el-input>
                </el-form-item>
                <el-form-item label="套餐均值:">
                    <el-input
                        v-model="formSet.averagePrice"
                        clearable
                        maxlength="30"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm"
                    >确定变更</el-button
                >
                <el-button @click="dialogBox = false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="配置" :visible.sync="dialogSetup">
            <el-form
                label-position="right"
                label-width="200px"
                :model="setupForm"
            >
                <el-form-item label="虚值方式:">
                    <el-select v-model="setupForm.activeStrategy">
                        <el-option
                            label="-未设置虚值方式-"
                            value=""
                        ></el-option>
                        <!-- <el-option label="A" value="1"></el-option>
                    <el-option label="B" value="2"></el-option> -->
                        <el-option
                            v-for="item in $store.getters.defaultStrategyList"
                            :key="item.dictKey"
                            :label="item.groupName"
                            :value="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="限速规则:">
                    <el-select
                        v-model="setupForm.speedLimitId"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in limitRuleList"
                            :label="item.name"
                            :value="item.id"
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否强制使用余额:">
                    <el-select v-model="setupForm.notForceYue">
                        <el-option label="-未设置-" value=""></el-option>
                        <el-option label="不强制" value="1"></el-option>
                        <el-option label="强制" value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="sureUpset"
                    >确定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="dialogSetup = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
import { limitRuleList } from "@/api/speedLimit/index.js";
import { getAgentType } from "@/api/agentManagement.js";
import { getFirstName } from "@/api/setMealManagment/setMeal.js";
import {
    getsetmealByagentId,
    getAgentList,
    addSetMeal_,
    deleteInterest_,
    getMealInfo,
    setMealEdit_,
} from "@/api/setMealManagment/setMealChange.js";
import { getAccountList } from "@/api/cardManagement/cardBill.js";
import { messageBox, confirmBox } from "@/utils/common.js";
import SearchSelect from "@/components/SearchSelect";
import resize from "@/mixins/resize.js";
import store from "@/store";
import { mapGetters } from "vuex";

const ERR_OK = 0;
export default {
    name: "setMealAgentAllocation",
    mixins: [resize],
    data() {
        return {
            limitRuleList: [],
            form: {
                agentId: "",
                distributionStatus: "",
                category: "",
                secondCategory: "",
                name: "",
            },
            // categorys:[],
            agentList: [],
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,

            dialogBox: false,
            formSet: {
                id: "",
                mealName: "",
                originalMoney: "",
                money: "",
                rebateRatio: 0,
                mealSort: "",
                sellType: "",
                averagePrice: "",
                secondRechargeRatio: 0,
                thirdRechargeRatio: 0,
                subsequentRechargeRatio: 0,
                secondRechargeCost: "",
                thirdRechargeCost: "",
                subsequentRechargeCost: "",
            },
            agentType: "",
            agentThreeName: "",
            agentTree: "",
            loginAgentId: "",
            agentIdVip: "",
            settl_type: "",
            currentNoProfitFlag: "",
            accountLists: [{ label: "全部", value: "" }],
            dialogSetup: false,
            setupForm: {
                id: "",
                editType: "2",
                activeStrategy: "",
                speedLimitId: "",
                notForceYue: "",
            },
            isWujiMeal: false,
            tieredRebateEnable: "0",
            maxRebateRatioPercent: null,
            parentMoney: null,
            miniOriginalMoney: null,
            parentSecondRechargeCost: null,
            parentThirdRechargeCost: null,
            parentSubsequentRechargeCost: null,
        };
    },
    computed: {
        ...mapGetters(["currentRole"]),
        isAdminAccount() {
            return this.currentRole === 0 || this.currentRole === "0";
        },
        isFirstLevelVipAgent() {
            return (
                (this.agentType == 4 || this.agentType == "4") &&
                (this.agentTree == 1 || this.agentTree == "1")
            );
        },
        showTieredRebateControl() {
            return this.isAdminAccount || this.isFirstLevelVipAgent;
        },
        tieredRebateEditable() {
            return this.tieredRebateEnable === "1";
        },
        isWithdrawRatioSellMode() {
            return this.normalizeSellType() === "1";
        },
        isSellPriceSellMode() {
            return this.normalizeSellType() === "2";
        },
        isTieredRebateRatioMode() {
            return this.tieredRebateEditable && this.isWithdrawRatioSellMode;
        },
        isTieredSellPriceMode() {
            return this.tieredRebateEditable && this.isSellPriceSellMode;
        },
        rebateRatioMaxLimit() {
            if (this.maxRebateRatioPercent != null) {
                return this.maxRebateRatioPercent;
            }
            return 100;
        },
        // 管理员/一级VIP新建套餐无上级限价；仅下级代理且存在有效上级原价时提示
        showMiniOriginalMoneyTip() {
            if (this.isAdminAccount || this.isFirstLevelVipAgent) {
                return false;
            }
            return (
                this.miniOriginalMoney != null && this.miniOriginalMoney > 0
            );
        },
        needCompareMiniOriginalMoney() {
            if (this.isAdminAccount || this.isFirstLevelVipAgent) {
                return false;
            }
            return (
                this.miniOriginalMoney != null && this.miniOriginalMoney > 0
            );
        },
    },
    mounted() {
        if (store.getters.categorys.length < 1) {
            store.dispatch("getCategory");
        }
        this.getAgentType();
        this._getAgentList();
        this._getsetmealByagentId();
        //  this.getFirstName()
        try {
            console.log("诺行版权");
        } catch (error) {
            console.log("notioni:" + error);
        }
    },
    // computed 已启用 mapGetters
    methods: {
        formatRechargeRatio(val, showDash = true) {
            if (val == null || val === "") {
                return showDash ? "-" : "";
            }
            const n = Number(val);
            if (isNaN(n)) {
                return showDash ? "-" : "";
            }
            const percent =
                n > 0 && n <= 1 ? Math.round(n * 100) : Math.round(n);
            return percent + "%";
        },
        formatTierRechargeDisplay(row, prefix) {
            const costKey =
                prefix === "second"
                    ? "secondRechargeCost"
                    : prefix === "third"
                    ? "thirdRechargeCost"
                    : "subsequentRechargeCost";
            const ratioKey =
                prefix === "second"
                    ? "secondRechargeRatio"
                    : prefix === "third"
                    ? "thirdRechargeRatio"
                    : "subsequentRechargeRatio";
            if (row[costKey] != null && row[costKey] !== "") {
                return row[costKey];
            }
            return this.formatRechargeRatio(row[ratioKey]);
        },
        parseApiRatioToPercent(val) {
            if (val == null || val === "") {
                return null;
            }
            const n = Number(val);
            if (isNaN(n)) {
                return null;
            }
            return n > 0 && n <= 1 ? Math.round(n * 100) : Math.round(n);
        },
        resolveParentRebateRatioPercent(res) {
            const raw =
                res.parentRebateRatio ??
                res.upRebateRatio ??
                res.maxRebateRatio ??
                res.fatherRebateRatio ??
                res.rebateRatioMax ??
                res.parentRatio;
            return this.parseApiRatioToPercent(raw);
        },
        resolveParentMoney(res) {
            const raw =
                res.parentMoney ??
                res.upMoney ??
                res.fatherMoney ??
                res.parentSellMoney ??
                res.parentMealMoney ??
                res.upAgentMoney ??
                res.parentAgentMoney;
            return this.parseMealMoney(raw);
        },
        resolveParentRechargeCost(res, tier) {
            const keyMap = {
                second: [
                    "parentSecondRechargeCost",
                    "upSecondRechargeCost",
                    "fatherSecondRechargeCost",
                    "parentSecondCost",
                ],
                third: [
                    "parentThirdRechargeCost",
                    "upThirdRechargeCost",
                    "fatherThirdRechargeCost",
                    "parentThirdCost",
                ],
                subsequent: [
                    "parentSubsequentRechargeCost",
                    "upSubsequentRechargeCost",
                    "fatherSubsequentRechargeCost",
                    "parentSubsequentCost",
                ],
            };
            const keys = keyMap[tier] || [];
            for (let i = 0; i < keys.length; i++) {
                const raw = res[keys[i]];
                if (raw != null && raw !== "") {
                    return this.parseMealMoney(raw);
                }
            }
            return null;
        },
        loadParentPriceLimits(res) {
            this.parentMoney = this.resolveParentMoney(res);
            this.parentSecondRechargeCost = this.resolveParentRechargeCost(
                res,
                "second"
            );
            this.parentThirdRechargeCost = this.resolveParentRechargeCost(
                res,
                "third"
            );
            this.parentSubsequentRechargeCost = this.resolveParentRechargeCost(
                res,
                "subsequent"
            );
        },
        validateParentOriginalMoney() {
            const original = this.parseMealMoney(this.formSet.originalMoney);
            if (original === null) {
                messageBox(this, "请填写有效的首次充值成本价", "提示");
                return false;
            }
            if (original <= 0) {
                messageBox(this, "首次充值成本价必须大于0", "提示");
                return false;
            }
            // 管理员或一级VIP新建/分配的套餐：不与上级价格比较
            if (!this.needCompareMiniOriginalMoney) {
                return true;
            }
            if (original < this.miniOriginalMoney) {
                messageBox(this, "首次充值成本价不可低于上级价格", "提示");
                return false;
            }
            return true;
        },
        validateParentSellingPrice() {
            if (!this.isSellPriceSellMode || this.parentMoney == null) {
                return true;
            }
            const money = this.parseMealMoney(this.formSet.money);
            if (money === null) {
                return true;
            }
            if (money < this.parentMoney) {
                messageBox(this, "不可低于上级售价", "提示");
                return false;
            }
            return true;
        },
        validateParentRechargeCostFloor(val, parentCost) {
            if (parentCost == null || !this.hasRechargeCostValue(val)) {
                return true;
            }
            const cost = this.parseMealMoney(val);
            if (cost === null) {
                return true;
            }
            if (cost < parentCost) {
                messageBox(this, "不可低于上级价格", "提示");
                return false;
            }
            return true;
        },
        normalizeSellType() {
            if (
                this.formSet.sellType === null ||
                this.formSet.sellType === undefined
            ) {
                return "";
            }
            return String(this.formSet.sellType);
        },
        isTieredEnabled() {
            const tier = this.tieredRebateEnable;
            return tier === "1" || tier === 1 || tier === true;
        },
        isSellPriceMeal() {
            return this.normalizeSellType() === "2";
        },
        hasRechargeCostValue(val) {
            return (
                val !== "" &&
                val != null &&
                val !== undefined &&
                String(val).trim() !== ""
            );
        },
        parseMealMoney(val) {
            const n = parseFloat(String(val == null ? "" : val).trim());
            return isNaN(n) ? null : n;
        },
        getMealPriceBounds() {
            return {
                original: this.parseMealMoney(this.formSet.originalMoney),
                money: this.parseMealMoney(this.formSet.money),
            };
        },
        validateBeforeSubmit() {
            if (!this.validateParentOriginalMoney()) {
                return false;
            }
            if (!this.validateParentSellingPrice()) {
                return false;
            }
            const money = parseFloat(String(this.formSet.money).trim());
            const original = parseFloat(
                String(this.formSet.originalMoney).trim()
            );
            if (
                this.isSellPriceSellMode &&
                !isNaN(money) &&
                !isNaN(original) &&
                money < original
            ) {
                messageBox(this, "首次充值售价不能低于原价", "提示");
                return false;
            }
            if (
                !this.isSellPriceSellMode &&
                this.maxRebateRatioPercent != null &&
                Number(this.formSet.rebateRatio) > this.maxRebateRatioPercent
            ) {
                messageBox(
                    this,
                    "首次充值提现比例不能高于上级设置的比例（" +
                        this.maxRebateRatioPercent +
                        "%）",
                    "提示"
                );
                return false;
            }
            if (this.isTieredRebateRatioMode) {
                const tierChecks = [
                    {
                        val: this.formSet.secondRechargeRatio,
                        label: "二次充值比",
                    },
                    {
                        val: this.formSet.thirdRechargeRatio,
                        label: "三次充值比",
                    },
                    {
                        val: this.formSet.subsequentRechargeRatio,
                        label: "后续充值比",
                    },
                ];
                for (let i = 0; i < tierChecks.length; i++) {
                    const item = tierChecks[i];
                    if (
                        this.maxRebateRatioPercent != null &&
                        Number(item.val) > this.maxRebateRatioPercent
                    ) {
                        messageBox(
                            this,
                            item.label +
                                "不能高于上级设置的比例（" +
                                this.maxRebateRatioPercent +
                                "%）",
                            "提示"
                        );
                        return false;
                    }
                }
            }
            if (this.isTieredEnabled() && this.isSellPriceMeal()) {
                if (!this.validateAllRechargeCostsStrict()) {
                    return false;
                }
            }
            return true;
        },
        validateAllRechargeCostsStrict() {
            const { original, money } = this.getMealPriceBounds();
            if (original === null || money === null) {
                messageBox(this, "请先填写有效的套餐原价和套餐售价", "提示");
                return false;
            }
            if (money <= original) {
                messageBox(
                    this,
                    "首次充值售价必须大于套餐原价（当前售价：" +
                        money +
                        "，原价：" +
                        original +
                        "）",
                    "提示"
                );
                return false;
            }
            const fields = [
                {
                    key: "secondRechargeCost",
                    label: "二次充值成本",
                    parentCost: this.parentSecondRechargeCost,
                },
                {
                    key: "thirdRechargeCost",
                    label: "三次充值成本",
                    parentCost: this.parentThirdRechargeCost,
                },
                {
                    key: "subsequentRechargeCost",
                    label: "后续充值成本",
                    parentCost: this.parentSubsequentRechargeCost,
                },
            ];
            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];
                const val = this.formSet[field.key];
                if (!this.hasRechargeCostValue(val)) {
                    messageBox(this, "请填写" + field.label, "提示");
                    return false;
                }
                if (!this.validateSingleRechargeCost(val, field.parentCost)) {
                    return false;
                }
            }
            return true;
        },
        validateSingleRechargeCost(val, parentCost) {
            if (!this.hasRechargeCostValue(val)) {
                return true;
            }
            const cost = this.parseMealMoney(val);
            const { original, money } = this.getMealPriceBounds();
            if (cost === null) {
                messageBox(this, "请输入有效的充值成本", "提示");
                return false;
            }
            if (original === null || money === null) {
                messageBox(
                    this,
                    "套餐原价或套餐售价无效，无法校验充值成本",
                    "提示"
                );
                return false;
            }
            if (cost < original) {
                messageBox(this, "充值成本不可低于套餐原价", "提示");
                return false;
            }
            if (cost > money) {
                messageBox(this, "充值成本不可高于套餐售价", "提示");
                return false;
            }
            if (!this.validateParentRechargeCostFloor(val, parentCost)) {
                return false;
            }
            return true;
        },
        buildSubmitParams() {
            const params = Object.assign({}, this.formSet);
            if (params.rebateRatio) {
                params.rebateRatio = params.rebateRatio / 100;
            }
            const sellType = this.normalizeSellType();
            if (this.isTieredEnabled()) {
                if (sellType === "1") {
                    if (params.secondRechargeRatio) {
                        params.secondRechargeRatio =
                            params.secondRechargeRatio / 100;
                    }
                    if (params.thirdRechargeRatio) {
                        params.thirdRechargeRatio =
                            params.thirdRechargeRatio / 100;
                    }
                    if (params.subsequentRechargeRatio) {
                        params.subsequentRechargeRatio =
                            params.subsequentRechargeRatio / 100;
                    }
                    params.secondRechargeCost = "";
                    params.thirdRechargeCost = "";
                    params.subsequentRechargeCost = "";
                } else if (sellType === "2") {
                    params.secondRechargeRatio = 0;
                    params.thirdRechargeRatio = 0;
                    params.subsequentRechargeRatio = 0;
                } else {
                    params.secondRechargeRatio = 0;
                    params.thirdRechargeRatio = 0;
                    params.subsequentRechargeRatio = 0;
                    params.secondRechargeCost = "";
                    params.thirdRechargeCost = "";
                    params.subsequentRechargeCost = "";
                }
            } else {
                params.secondRechargeRatio = 0;
                params.thirdRechargeRatio = 0;
                params.subsequentRechargeRatio = 0;
                params.secondRechargeCost = "";
                params.thirdRechargeCost = "";
                params.subsequentRechargeCost = "";
            }
            if (sellType !== "2") {
                params.secondRechargeCost = "";
                params.thirdRechargeCost = "";
                params.subsequentRechargeCost = "";
            }
            if (sellType !== "1") {
                params.secondRechargeRatio = 0;
                params.thirdRechargeRatio = 0;
                params.subsequentRechargeRatio = 0;
            }
            params.tieredRebateEnable = this.tieredRebateEnable;
            return params;
        },
        sureUpset() {
            setMealEdit_(this.setupForm).then((res) => {
                if (res.system_result_key == 0) {
                    this.$message({
                        showClose: true,
                        message: "配置成功",
                        type: "success",
                    });
                    this._getsetmealByagentId();
                    this.dialogSetup = false;
                }
            });
        },
        setup(id, accountId) {
            this.setupForm.activeStrategy = "";
            this.dialogSetup = true;
            this.setupForm.id = id;

            limitRuleList({ accountId }).then((res) => {
                this.limitRuleList = [];
                let list = res.rows;
                if (res.rows.length > 0) {
                    list.forEach((item) => {
                        this.limitRuleList.push({
                            name: item.name,
                            id: item.id,
                        });
                    });
                }

                getMealInfo({ id }).then((res) => {
                    this.setupForm.activeStrategy = res.activeStrategy
                        ? res.activeStrategy.toString()
                        : "";
                    this.setupForm.speedLimitId = res.speedLimitId;
                    this.setupForm.notForceYue = res.notForceYue.toString();
                });
            });
        },
        secondClick(val) {
            if (this.accountLists.length == 1 && val) {
                this.$alert("请先选择类别", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }
        },
        getSecondLists(val) {
            this.form.secondCategory = "";
            this.accountLists = [{ label: "全部", value: "" }];
            getAccountList({ category: val }).then((res) => {
                if (res.length > 0) {
                    res.forEach((item) => {
                        this.accountLists.push({
                            label: item.accountName,
                            value: item.secondCategory,
                        });
                    });
                }
            });
        },
        // changeSecondList(val){
        //   if(val==""){
        //    this.$alert('请选择类别', '提示', {
        // 						confirmButtonText: '确定',
        // 					});
        //   }
        // },
        updateSort(val, id, num) {
            if (num == 1 && (!val || val === "")) {
                return;
            }
            if (num == 1 && isNaN(val)) {
                return;
            }
            if (num == 4) {
                if (val.length > 15) {
                    messageBox(this, "输入长度最大为15个字符", "提示");
                    return;
                }
            }

            let postData = {
                id,
                editType: 3,
            };
            let parms = {};
            if (num == 1) {
                parms.mealSort = val;
            } else if (num == 2) {
                parms.hideFlag = val;
            } else if (num == 3) {
                parms.label = val;
            } else if (num == 4) {
                parms.redMark = val;
            }
            Object.assign(parms, postData);
            setMealEdit_(parms)
                .then((res) => {
                    this._getsetmealByagentId();
                })
                .catch((res) => {
                    messageBox(
                        this,
                        "请求错误",
                        "操作繁忙请稍后重试或联系客服。"
                    );
                });
        },
        getAgentType() {
            getAgentType().then((res) => {
                this.agentType = res.agentType;
                this.agentThreeName = res.agentThreeName;
                this.agentTree = res.agentTree;
                this.loginAgentId = res.agentId;
                this.settl_type = res.settlType;
                console.log(this.settl_type);
            });
        },
        //  getFirstName(){
        //     getFirstName().then((res)=>{
        //     this.categorys = []
        //     if(res.length>0){
        //         res.forEach((item) => {
        //             if(item.firstName){
        //                 this.categorys.push({
        //                     name:item.firstName,
        //                     value:item.category
        //                 })
        //             }
        //         })
        //     }
        //     })
        // },
        categoryString(category) {
            let cuCatagorys;
            if (store.getters.categorys.length > 0) {
                store.getters.categorys.forEach((item) => {
                    if (category == item.value) {
                        cuCatagorys = item.name;
                    }
                });
            }
            return cuCatagorys;
        },
        submitForm() {
            if (!this.validateParentOriginalMoney()) {
                return false;
            }
            if (!this.validateParentSellingPrice()) {
                return false;
            }
            if (this.isTieredEnabled() && this.isSellPriceMeal()) {
                if (!this.validateAllRechargeCostsStrict()) {
                    return false;
                }
            }
            if (!this.validateBeforeSubmit()) {
                return false;
            }
            const params = this.buildSubmitParams();
            setMealEdit_(params).then((res) => {
                if (
                    typeof res.wodeyongjinError !== "undefined" &&
                    res.wodeyongjinError === true
                ) {
                    messageBox(this, "分销比例设置错误，请重新设置");
                    return;
                }
                this.dialogBox = false;
                this._getsetmealByagentId();
            });
        },
        editSetMeal(id, noProfitFlag) {
            this.formSet.id = id;
            this.currentNoProfitFlag = noProfitFlag;
            this._getMealInfo(id);
        },
        reloadPageData() {
            this._getsetmealByagentId();
        },
        addSetMeal(id) {
            var params = Object.assign({ id }, this.form);
            addSetMeal_(params).then((res) => {
                this.handleResult(res);
            });
        },
        deleteInterest(id) {
            confirmBox(
                this,
                "是否确定移除该套餐，移除后将不能充值该套餐?",
                null,
                () => {
                    var params = Object.assign({ id }, this.form);
                    deleteInterest_(params).then((res) => {
                        this.handleResult(res);
                    });
                }
            );
        },
        handleResult(res) {
            if (
                typeof res.wodeyongjinError !== "undefined" &&
                res.wodeyongjinError === true
            ) {
                messageBox(this, "分销比例设置错误，请重新设置");
            }
            if (res.slide_msg_key == 1) {
                messageBox(res.slide_msg_message_key);
            }
            this._getsetmealByagentId();
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this._getsetmealByagentId();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this._getsetmealByagentId();
        },

        _getsetmealByagentId() {
            let params = {};
            params.pageSize = this.pageSize;
            params.pageNo = this.currentPage;
            Object.assign(params, this.form);
            getsetmealByagentId(params).then((res) => {
                // console.log(res)
                this.total = res.total;
                this.currentPage = res.pageNo;
                this.pageSize = res.pageSize;
                this.tableData = res.rows;
            });
        },
        _getAgentList() {
            getAgentList(this.form).then((res) => {
                this.agentList = res.map((item) => {
                    return {
                        label: item.name,
                        value: item.id,
                    };
                });
            });
        },
        _getMealInfo(id) {
            getMealInfo({ id }).then((res) => {
                this.dialogBox = true;
                this.formSet.mealName = res.name;
                this.formSet.originalMoney = res.originalMoney;
                this.miniOriginalMoney = this.parseMealMoney(
                    res.miniOriginalMoney
                );
                this.formSet.money = res.money;
                this.formSet.rebateRatio = Number(res.rebateRatio) * 100;
                // this.formSet.rebateRatio = res.rebateRatio
                this.formSet.mealSort = res.mealSort;
                this.formSet.sellType = res.sellType + "";
                this.agentIdVip = res.agentIdVip;
                this.formSet.averagePrice = res.averagePrice;
                this.formSet.secondRechargeRatio =
                    res.secondRechargeRatio != null &&
                    res.secondRechargeRatio !== ""
                        ? this.parseApiRatioToPercent(
                              res.secondRechargeRatio
                          ) || 0
                        : 0;
                this.formSet.thirdRechargeRatio =
                    res.thirdRechargeRatio != null &&
                    res.thirdRechargeRatio !== ""
                        ? this.parseApiRatioToPercent(res.thirdRechargeRatio) ||
                          0
                        : 0;
                this.formSet.subsequentRechargeRatio =
                    res.subsequentRechargeRatio != null &&
                    res.subsequentRechargeRatio !== ""
                        ? this.parseApiRatioToPercent(
                              res.subsequentRechargeRatio
                          ) || 0
                        : 0;
                this.formSet.secondRechargeCost =
                    res.secondRechargeCost != null
                        ? String(res.secondRechargeCost)
                        : "";
                this.formSet.thirdRechargeCost =
                    res.thirdRechargeCost != null
                        ? String(res.thirdRechargeCost)
                        : "";
                this.formSet.subsequentRechargeCost =
                    res.subsequentRechargeCost != null
                        ? String(res.subsequentRechargeCost)
                        : "";
                const tierRaw = res.tieredRebateEnable;
                this.tieredRebateEnable =
                    tierRaw === 1 || tierRaw === "1" || tierRaw === true
                        ? "1"
                        : "0";
                this.maxRebateRatioPercent =
                    this.resolveParentRebateRatioPercent(res);
                this.loadParentPriceLimits(res);

                //  根据后端返回的条件进行判断
                if (res.ifWuJi) {
                    this.isWujiMeal = true;
                } else {
                    this.isWujiMeal = false;
                }
            });
        },
        changeSellType(val) {
            if (val === "1") {
                this.formSet.secondRechargeCost = "";
                this.formSet.thirdRechargeCost = "";
                this.formSet.subsequentRechargeCost = "";
            } else if (val === "2") {
                this.formSet.secondRechargeRatio = 0;
                this.formSet.thirdRechargeRatio = 0;
                this.formSet.subsequentRechargeRatio = 0;
            } else if (val === "0") {
                this.formSet.secondRechargeCost = "";
                this.formSet.thirdRechargeCost = "";
                this.formSet.subsequentRechargeCost = "";
                this.formSet.secondRechargeRatio = 0;
                this.formSet.thirdRechargeRatio = 0;
                this.formSet.subsequentRechargeRatio = 0;
            }
        },
        onTieredRebateEnableChange(val) {
            if (val !== "1") {
                this.formSet.secondRechargeCost = "";
                this.formSet.thirdRechargeCost = "";
                this.formSet.subsequentRechargeCost = "";
                this.formSet.secondRechargeRatio = 0;
                this.formSet.thirdRechargeRatio = 0;
                this.formSet.subsequentRechargeRatio = 0;
            }
        },
    },
    components: {
        SearchSelect,
    },
};
</script>

<style scoped>
.setMealAllocation .recharge-ratio-cell {
    display: inline-block;
    min-width: 48px;
    padding: 2px 8px;
    background-color: #f5f7fa;
    border-radius: 2px;
    color: #606266;
    line-height: 22px;
}
.setMealAllocation .form-tip {
    margin-left: 8px;
    font-size: 12px;
    color: #909399;
}
.setMealAllocation .field-readonly-gray >>> .el-input__inner {
    background-color: #f5f7fa;
    color: #606266;
    cursor: not-allowed;
}
.setMealAllocation .field-readonly-gray.el-input-number >>> .el-input__inner {
    background-color: #f5f7fa;
    color: #606266;
    cursor: not-allowed;
}
</style>
